/* eslint-disable camelcase */
import React, { useState } from 'react';
import {
    SurgeryNote,
    SurgeryClose,
    SurgeryInput,
    Div,
    Line,
    DesktopDiv,
    Hideflex,
    ButtonDiv,
    StyledDiv,
    DisplayDiv,
    SurgeryNoteCharactersCount,
    Subtitle,
    SubtitleDiv,
    DesktopDivWithBorder,
    DesktopContainer,
    AccountContainer,
} from './CustomerCareNotes.styled';
import {
    isMobileDevice,
    checkImpersonationActive,
    checkProxyActive, 
    isLandscape, 
    logErrorToConsole,
} from 'src/utils/util';
import CloseProduct from 'src/assets/images/CloseProduct.svg';
import DeleteIcon from 'src/assets/images/DeleteIcon.svg';
import MDIedit from 'src/assets/images/MDIedit.svg';
import TickBlue from 'src/assets/images/TickBlue.svg';
import CloseBlue from 'src/assets/images/CloseBlue.svg';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import MDIEditDisable from 'src/assets/images/MDIEditDisable.svg';
import { useSelector, useDispatch } from 'react-redux';
import {
    convertTime24To12,
    isIOSiPhoneDevice,
    getAdditionalTextareaLimit,
} from 'src/utils/util';
// import handleEditSaveTwo from './handlers/editHandlers';
import {
    formatDateddmmmyy,
} from 'src/utils/dateUtils';
import { sizes } from 'src/styles/Media.styled';
import { useTranslation } from 'react-i18next';
import AddedMoreThanTenItems from 'src/pages/scheduleSurgery/components/surgery/notifications/AddedMoreThanTenItems';
import {
    handleConsignmentAddNotes,
    handleConsignmentBillingNotes,
    handleEquityNotes,
    handleReportUsageNotes,
    handleSurgeryNotes,
} from 'src/common/redux/actions';
import {
    AccountGridContainer,
    AccountGrid,
    ImageContainer,
    ImageBox,
    MainTitle,
} from 'src/common/components/reviewAndSubmitNotes/reviewAndSubmitNotes.styled.jsx';
import DownArrowFilter from 'src/assets/images/DownArrowFilter.svg';
import { isIpad } from 'src/utils/util';
import { makeStyles } from '@material-ui/core/styles'; 
import NotesOneContainer from './NotesOneContainer';
import NotesTwoContainer from './NotesTwoContainer';
import { handleSave, handleEditSaveTwo, handleDelete} from './notesHandlers';
import SuccessMsgContainer from './SuccessMsgContainer';
import NotesOneDisplay from './NotesOneDisplay';
import NotesTwoDisplay from './NotesTwoDisplay';
import UsageAdjNoteSection from './UsageAdjNoteSection';
import { useEffectWithErrorLogging} from 'src/utils/useEffectWithErrorLogging';

const CustomerCareNotes = ({
    setViewNotes,
    setNotesCount,
    noteOneHeader,
    noteTwoHeader,
    noteOneSubHeader,
    noteTwoSubHeader,
    isSurgery,
    isFromEquity,
    isFromConsignmentAdd,
    isFromConsignmentBilling,
    isFromReportUsage,
    isTransferSurgery = false,
    notesVisibility = []
}) => {
    const { notesData, displayName } = useSelector((state) => ({
        notesData: state.HeaderNotesReducer,
        displayName: state.loginReducer.hybrisUserDetails.displayName,
    }));

    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );

    const bannerHeight = useSelector(
        (state) => state.loginReducer.bannerHeight
    );

    const adjustmentDisEnabled = useSelector(
        (state) => state.loginReducer?.hybrisUserDetails?.adjustmentDisEnabled
    );
    // Adj notes section shows based on the same adj flag used for the "Adj" label,
    // regardless of whether an item currently has an adj qty.
    const showUsageAdjNotes = isFromReportUsage && adjustmentDisEnabled;

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isIpadDevice = isIpad();
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const useStyles = makeStyles((theme) => ({
    ipadWidth: {
        width: 'auto', // Default for desktop
        [theme.breakpoints.between('sm', 'md')]: {
            width: '100%', // iPad/tablet only (sm=600px, md=960px)
        },
    },
}));
    const classes = useStyles();
    const charCountLimit = 4000;
    const [notesOnetext, setNotesOnetext] = useState('');
    const [notesTwoText, setNotesTwoText] = useState('');
    const [notesThreeText, setNotesThreeText] = useState('');
    const [notesOneDisplay, setNotesOneDisplay] = useState([]);
    const [notesTwoDisplay, setNotesTwoDisplay] = useState([]);
    const [notesThreeDisplay, setNotesThreeDisplay] = useState([]);
    const [surgeryNotesPopup, setSurgeryNotesPopup] = useState(false);
    const [editNoteOne, setEditNoteOne] = useState('');
    const [editNoteValue, setEditNoteOneValue] = useState(null);
    const [editNoteTwoValue, setEditNoteTwoValue] = useState(null);
    const [editNoteTwo, setEditNoteTwo] = useState('');
    const [editNoteThree, setEditNoteThree] = useState('');
    const [editNoteThreeValue, setEditNoteThreeValue] = useState(null);
    const [successMessageOne, setShowSuccessMessageOne] = useState(false);
    const [successMessageTwo, setShowSuccessMessageTwo] = useState(false);
    const [successMessageThree, setShowSuccessMessageThree] = useState(false);
    const [changeInWidth, setChangeInWidth] = useState(false);
    const [expandedCard1, setExpandedCard1] = useState({
        itemDetails: false,
    });

    const [expandedCard2, setExpandedCard2] = useState({
        itemDetails: false,
    });

    const [expandedCard3, setExpandedCard3] = useState({
        itemDetails: false,
    });

    const toggleCard1 = (name, value) => {
        setExpandedCard1({
            ...expandedCard1,
            [name]: value,
        });
    };

    const toggleCard2 = (name, value) => {
        setExpandedCard2({
            ...expandedCard2,
            [name]: value,
        });
    };

    const toggleCard3 = (name, value) => {
        setExpandedCard3({
            ...expandedCard3,
            [name]: value,
        });
    };


    const [textAreaOneCharLimit, setTextAreaOneCharLimit] =
        useState(charCountLimit);
    const [textAreaTwoCharLimit, setTextAreaTwoCharLimit] =
        useState(charCountLimit);
    
    const [isMobileLandscapeView, setIsMobileLandscapeView] = useState(isMobileDevice() && isLandscape());
    const isReportUsageMobileView =
        isFromReportUsage &&
        isMobileDevice() &&
        !isMobileLandscapeView;

        
    useEffectWithErrorLogging(() => {
        const handleResize = () => {
            setChangeInWidth(prev => !prev);
            const newValue = isMobileDevice() && isLandscape();
            setIsMobileLandscapeView(newValue);
        };

        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        };
    }, []);
    useEffectWithErrorLogging(() => {
        let notesOne = [];
        let notesTwo = [];
        if (isSurgery) {
            let noteOneTemp = isTransferSurgery
                ? notesData?.surgeryNotes[0]?.customerNotes.filter((note) => {
                      return note?.isTransferSurgery === true;
                  })
                : notesData?.surgeryNotes[0]?.customerNotes;
            let noteTwoTemp = isTransferSurgery
                ? notesData?.surgeryNotes[0]?.surgeryNotes.filter((note) => {
                      return note?.isTransferSurgery === true;
                  })
                : notesData?.surgeryNotes[0]?.surgeryNotes;
            notesOne = noteOneTemp
                ? noteOneTemp.sort((a, b) => {
                      return (
                          new Date(b.creationDate) - new Date(a.creationDate)
                      );
                  })
                : [];

            notesTwo = noteTwoTemp
                ? noteTwoTemp.sort((a, b) => {
                      return (
                          new Date(b.creationDate) - new Date(a.creationDate)
                      );
                  })
                : [];
            // notesOne.length>0 && notesOne.map((pr)=>pr = {...pr,isNew:true});
        } else if (isFromConsignmentBilling) {
            notesOne = notesData?.consignmentBillingNotes[0]
                ?.consignmentBillingNotes
                ? notesData?.consignmentBillingNotes[0]?.consignmentBillingNotes.sort(
                      (a, b) => {
                          return (
                              new Date(b.creationDate) -
                              new Date(a.creationDate)
                          );
                      }
                  )
                : [];
            notesTwo = notesData?.consignmentBillingNotes[0]
                ?.consignmentReplenishmentNotes
                ? notesData?.consignmentBillingNotes[0]?.consignmentReplenishmentNotes.sort(
                      (a, b) => {
                          return (
                              new Date(b.creationDate) -
                              new Date(a.creationDate)
                          );
                      }
                  )
                : [];
        } else if (isFromEquity) {
            notesOne =
                 (isMobileDevice() && !isMobileLandscapeView) && notesData?.equityNotes[0]?.equityNotes
                    ? notesData?.equityNotes[0]?.equityNotes.sort((a, b) => {
                          return (
                              new Date(b.creationDate) -
                              new Date(a.creationDate)
                          );
                      })
                    : [];
            notesTwo =
                 (!isMobileDevice() || (isMobileLandscapeView)) && notesData?.equityNotes[0]?.equityNotes
                    ? notesData?.equityNotes[0]?.equityNotes.sort((a, b) => {
                          return (
                              new Date(b.creationDate) -
                              new Date(a.creationDate)
                          );
                      })
                    : [];
        } else if (isFromConsignmentAdd) {
            notesOne =
                (isMobileDevice() && !isMobileLandscapeView) &&
                notesData?.consignmentAddNotes[0]?.consignmentAddNotes
                    ? notesData?.consignmentAddNotes[0]?.consignmentAddNotes.sort(
                          (a, b) => {
                              return (
                                  new Date(b.creationDate) -
                                  new Date(a.creationDate)
                              );
                          }
                      )
                    : [];
            notesTwo =
                (!isMobileDevice() || (isMobileLandscapeView)) &&
                notesData?.consignmentAddNotes[0]?.consignmentAddNotes
                    ? notesData?.consignmentAddNotes[0]?.consignmentAddNotes.sort(
                          (a, b) => {
                              return (
                                  new Date(b.creationDate) -
                                  new Date(a.creationDate)
                              );
                          }
                      )
                    : [];
        } else if (isFromReportUsage) {
            notesOne = notesData?.reportUsageNotes[0]?.reportUsageNotes
                ? notesData?.reportUsageNotes[0]?.reportUsageNotes.sort(
                      (a, b) => {
                          return (
                              new Date(b.creationDate) -
                              new Date(a.creationDate)
                          );
                      }
                  )
                : [];
            notesTwo = notesData?.reportUsageNotes[0]?.reportReplenishmentNotes
                ? notesData?.reportUsageNotes[0]?.reportReplenishmentNotes.sort(
                      (a, b) => {
                          return (
                              new Date(b.creationDate) -
                              new Date(a.creationDate)
                          );
                      }
                  )
                : [];
        }
        let modifySurgeryNotes = [];
        let modifySurgeryNotesOne = [];
        isSurgery &&
            notesTwo.length > 0 &&
            notesTwo.map((pr) => {
                if (pr.typeOfNote == 'UserNotes') {
                    pr = { ...pr, isDelete: true, isEdit: true };
                } else {
                    pr = { ...pr, isDelete: true };
                }
                modifySurgeryNotes.push(pr);
            });
        setNotesOneDisplay(
            modifySurgeryNotesOne.length > 0 ? modifySurgeryNotesOne : notesOne
        );
        setNotesTwoDisplay(
            modifySurgeryNotes.length > 0 ? modifySurgeryNotes : notesTwo
        );
        setNotesThreeDisplay(
            isFromReportUsage &&
                notesData?.reportUsageNotes?.[0]?.reportUsageAdjNotes
                ? [...notesData.reportUsageNotes[0].reportUsageAdjNotes].sort(
                      (a, b) =>
                          new Date(b.creationDate) - new Date(a.creationDate)
                  )
                : []
        );
    }, [notesData,isMobileLandscapeView]);

    // Using the imported handleSave function
    const handleSaveLocal = (from) => {
        handleSave({
            from,
            isSurgery,
            isFromConsignmentBilling,
            isFromEquity,
            isFromConsignmentAdd,
            isFromReportUsage,
            isTransferSurgery,
            notesOnetext,
            notesTwoText,
            notesThreeText,
            notesOneDisplay,
            notesTwoDisplay,
            notesThreeDisplay,
            displayName,
            dispatch,
            setNotesOnetext: typeof setNotesOnetext === 'function' ? setNotesOnetext : () => {},
            setNotesTwoText: typeof setNotesTwoText === 'function' ? setNotesTwoText : () => {},
            setNotesThreeText: typeof setNotesThreeText === 'function' ? setNotesThreeText : () => {},
        });
    };

    const handleEditOne = (item, itemIndex) => {
        setEditNoteOne(itemIndex);
        setEditNoteOneValue(item.note);
    };
    const handleEditTwo = (item, itemIndex) => {
        setEditNoteTwo(itemIndex);
        setEditNoteTwoValue(item.note);
    };

    const handleCloseEditOne = () => {
        setEditNoteOne(null);
        setEditNoteOneValue(null);
    };
    const handleCloseEditTwo = () => {
        setEditNoteTwo(null);
        setEditNoteTwoValue(null);
    };

  const handleEditSaveOne = (index) => {
    const valueToSave =
        editNoteValue !== null && editNoteValue !== undefined
            ? editNoteValue
            : notesOneDisplay[index]?.note;

    if (!valueToSave || valueToSave.trim() === '') {
        handleDeleteLocal(null, index, 'notes1');
        setEditNoteOne(null);
        setEditNoteOneValue(null);
        setNotesCount(prev => prev - 1);
        return;
    }

    const updatedNotesOneDisplay = [...notesOneDisplay];
    updatedNotesOneDisplay[index] = {
        ...updatedNotesOneDisplay[index],
        note: valueToSave.trim(),
    };
    setNotesOneDisplay(updatedNotesOneDisplay);

    if (isSurgery) {
        const newNotes = [
            {
                customerNotes: updatedNotesOneDisplay,
                surgeryNotes: [...notesTwoDisplay],
            },
        ];
        dispatch(handleSurgeryNotes(newNotes));
    } else if (isFromConsignmentBilling) {
        const newNotes = [
            {
                consignmentBillingNotes: updatedNotesOneDisplay,
                consignmentReplenishmentNotes: [...notesTwoDisplay],
            },
        ];
        dispatch(handleConsignmentBillingNotes(newNotes));
    } else if (isFromReportUsage) {
        const newNotes = [
            {
                reportUsageNotes: updatedNotesOneDisplay,
                reportReplenishmentNotes: [...notesTwoDisplay],
                reportUsageAdjNotes: [...notesThreeDisplay],
            },
        ];
        dispatch(handleReportUsageNotes(newNotes));
    } else if (isFromEquity) {
        const newNotes = [
            {
                equityNotes: updatedNotesOneDisplay,
            },
        ];
        dispatch(handleEquityNotes(newNotes));
    } else if (isFromConsignmentAdd) {
        const newNotes = [
            {
                consignmentAddNotes: updatedNotesOneDisplay,
            },
        ];
        dispatch(handleConsignmentAddNotes(newNotes));
    }
    setEditNoteOne(null);
    setEditNoteOneValue(null);
};
   const handleEditSaveTwoLocal = (index) => {
       handleEditSaveTwo({
           index,
           notesTwoDisplay,
           notesOneDisplay,
           notesThreeDisplay,
           editNoteTwoValue,
           isSurgery,
           isFromConsignmentBilling,
           isFromEquity,
           isFromConsignmentAdd,
           isFromReportUsage,
           dispatch,
           setEditNoteTwo,
           setEditNoteTwoValue,
           setNotesCount,
           handleDelete: handleDeleteLocal
       });
   };

    // Using the imported handleDelete function from our separate module
    const handleDeleteLocal = (item, itemIndex, type) => {
        handleDelete({
            itemIndex,
            type,
            isSurgery,
            isFromConsignmentBilling,
            isFromEquity,
            isFromConsignmentAdd,
            isFromReportUsage,
            notesOneDisplay,
            notesTwoDisplay,
            notesThreeDisplay,
            dispatch,
            setEditNoteOne,
            setEditNoteTwo
        });
    };

    const handleDeleteThree = (item, index) => {
        const updated = notesThreeDisplay.filter((_, i) => i !== index);
        setNotesThreeDisplay(updated);
        if (item?.isNew) {
            setNotesCount((prev) => (prev > 0 ? prev - 1 : 0));
        }
        dispatch(
            handleReportUsageNotes([
                {
                    reportUsageNotes: [...notesOneDisplay],
                    reportReplenishmentNotes: [...notesTwoDisplay],
                    reportUsageAdjNotes: updated,
                },
            ])
        );
    };

    const handleEditThree = (item, itemIndex) => {
        setEditNoteThree(itemIndex);
        setEditNoteThreeValue(item.note);
    };

    const handleCloseEditThree = () => {
        setEditNoteThree(null);
        setEditNoteThreeValue(null);
    };

    const handleEditSaveThree = (index) => {
        const valueToSave =
            editNoteThreeValue !== null && editNoteThreeValue !== undefined
                ? editNoteThreeValue
                : notesThreeDisplay[index]?.note;

        if (!valueToSave || valueToSave.trim() === '') {
            handleDeleteThree(notesThreeDisplay[index], index);
            setEditNoteThree(null);
            setEditNoteThreeValue(null);
            return;
        }

        const updatedNotesThreeDisplay = [...notesThreeDisplay];
        updatedNotesThreeDisplay[index] = {
            ...updatedNotesThreeDisplay[index],
            note: valueToSave.trim(),
        };
        setNotesThreeDisplay(updatedNotesThreeDisplay);
        dispatch(
            handleReportUsageNotes([
                {
                    reportUsageNotes: [...notesOneDisplay],
                    reportReplenishmentNotes: [...notesTwoDisplay],
                    reportUsageAdjNotes: updatedNotesThreeDisplay,
                },
            ])
        );
        setEditNoteThree(null);
        setEditNoteThreeValue(null);
        setShowSuccessMessageThree(true);
        setTimeout(() => {
            try {
                setShowSuccessMessageThree(false);
            } catch (error) {
                logErrorToConsole(error);
            }
        }, 4000);
    };

    const clearSurgeryNotes = (from) => {
        if (from === 'noteOne') {
            setNotesOnetext('');
        } else if (from === 'noteTwo') {
            setNotesTwoText('');
        } else if (from === 'noteThree') {
            setNotesThreeText('');
        }
    };

    useEffectWithErrorLogging(() => {
        if (
            isIOSiPhoneDevice() &&
            notesOnetext?.length > 0 &&
            getAdditionalTextareaLimit(notesOnetext) > 0
        ) {
            setTextAreaOneCharLimit(
                charCountLimit + getAdditionalTextareaLimit(notesOnetext)
            );
        } else {
            setTextAreaOneCharLimit(charCountLimit);
        }
    }, [notesOnetext]);

    useEffectWithErrorLogging(() => {
        if (
            isIOSiPhoneDevice() &&
            notesTwoText?.length > 0 &&
            getAdditionalTextareaLimit(notesTwoText) > 0
        ) {
            setTextAreaTwoCharLimit(
                charCountLimit + getAdditionalTextareaLimit(notesTwoText)
            );
        } else {
            setTextAreaTwoCharLimit(charCountLimit);
        }
    }, [notesTwoText]);

    const surgeryNoteChangeHandler = (e, notesFrom) => {
        let note = e.target.value;
        if (notesFrom === 'noteOne') {
            if (note?.length > charCountLimit) {
                const sliceLastIdx = charCountLimit - note?.length;
                note = note.slice(0, sliceLastIdx);
            }
            setNotesOnetext(note);
        }
        if (notesFrom === 'noteTwo') {
            if (note?.length > charCountLimit) {
                const sliceLastIdx = charCountLimit - note?.length;
                note = note.slice(0, sliceLastIdx);
            }
            setNotesTwoText(note);
        }
        if (notesFrom === 'noteThree') {
            if (note?.length > charCountLimit) {
                const sliceLastIdx = charCountLimit - note?.length;
                note = note.slice(0, sliceLastIdx);
            }
            setNotesThreeText(note);
        }
        if (note?.length > 4000) {
            setSurgeryNotesPopup(true);
        }
    };

    const handlePopupOnKeyPress = () => {
        if (
            notesOnetext?.length >= charCountLimit ||
            notesTwoText?.length >= charCountLimit
        ) {
            setSurgeryNotesPopup(true);
        }
    };

    return (
        <>
            <Div>
                {!isReportUsageMobileView &&
                window.innerWidth > sizes.mobileDevice ? (
                    <DesktopContainer>
                        {notesVisibility.includes('customerNotes') && (
                            <DesktopDivWithBorder>
                                <DisplayDiv>
                                    <SubtitleDiv>
                                        <Subtitle>{noteOneHeader}</Subtitle>
                                        {!isIpadDevice ? (
                                            <SurgeryNoteCharactersCount margin="0px 5px 0px 0px">
                                                {`${
                                                    charCountLimit - notesOnetext?.length < 0
                                                        ? 0
                                                        : charCountLimit - notesOnetext?.length
                                                } ${t(
                                                    'equity.surgery.remainchar'
                                                )}`}
                                            </SurgeryNoteCharactersCount>
                                        ) : null}
                                    </SubtitleDiv>
                                    {isIpadDevice ? (
                                        <SurgeryNoteCharactersCount margin="0px 5px 5px 0px">
                                            {`${
                                                charCountLimit - notesOnetext?.length < 0
                                                    ? 0
                                                    : charCountLimit - notesOnetext?.length
                                            } ${t(
                                                'equity.surgery.remainchar'
                                            )}`}
                                        </SurgeryNoteCharactersCount>
                                    ) : null}
                                    <SurgeryInput
                                        placeholder={
                                            isFromConsignmentAdd || isFromEquity
                                                ? t(
                                                      'reportUsage.EnterCustomerCareNotes'
                                                  )
                                                : isFromConsignmentBilling
                                                ? t(
                                                      'common.enterCustomerCareBillingNotes'
                                                  )
                                                : isFromReportUsage
                                                ? t(
                                                      'common.enterCustomerCareUsageNotes'
                                                  )
                                                : t(
                                                      'common.enterCustomerCareSurgeryNotes'
                                                  )
                                        }
                                        value={notesOnetext}
                                        onChange={(e) =>
                                            surgeryNoteChangeHandler(
                                                e,
                                                'noteOne'
                                            )
                                        }
                                        maxLength={textAreaOneCharLimit}
                                        onKeyPress={handlePopupOnKeyPress}
                                    ></SurgeryInput>

                                    <ButtonDiv justifyContent={'flex-end'}>
                                        <Button
                                            id={
                                                'common-surgery-notes-clear-button'
                                            }
                                            width={'102px'}
                                            mobileWidth={'150px'}
                                            height={'38px'}
                                            show={true}
                                            variant={ButtonStyles.secondary}
                                            clearNotesBg={true}
                                            margin={'0px 18px 0px 0px'}
                                            clicked={() => {
                                                try {
                                                    notesOnetext.length > 0
                                                        ? clearSurgeryNotes(
                                                              'noteOne'
                                                          )
                                                        : setViewNotes(false);
                                                } catch (error) {
                                                    logErrorToConsole(error);
                                                }
                                            }}
                                        >
                                            <StyledDiv>
                                                {t('more.common.cancel')}
                                            </StyledDiv>
                                        </Button>
                                        <Button
                                            id={
                                                'common-surgery-notes-save-button-one'
                                            }
                                            width={'102px'}
                                            mobileWidth={'150px'}
                                            height={'38px'}
                                            show={true}
                                            variant={
                                                notesOnetext.trim().length > 0
                                                    ? ButtonStyles?.primary
                                                    : ButtonStyles?.surgeryNotesDisabled
                                            }
                                            disabled={notesOnetext.trim().length === 0}
                                            clicked={() => {
                                                try {
                                                    if (
                                                        notesOnetext.trim().length >
                                                        0
                                                    ) {
                                                        setNotesCount(
                                                            (prev) => prev + 1
                                                        );
                                                        handleSaveLocal('noteOne');
                                                    }
                                                } catch (error) {
                                                    logErrorToConsole(error);
                                                }
                                            }}
                                        >
                                            <StyledDiv>
                                                {t('more.common.save')}
                                            </StyledDiv>
                                        </Button>
                                    </ButtonDiv>
                                    <Line></Line>
                                </DisplayDiv>
                                {(!isFromEquity && !isFromConsignmentAdd)? ( 
                                    <div style={{ marginTop: '20px' }}>
                                        <SubtitleDiv>
                                            <Subtitle margin="0 0 5px 0">
                                                {noteOneSubHeader}
                                            </Subtitle>
                                            {successMessageOne &&
                                            window.innerWidth >= sizes.mobileDevice ? (
                                                <SuccessMsgContainer
                                                    marginRight={'5px'}
                                                    className={classes.ipadWidth}
                                                />
                                            ) : null}
                                        </SubtitleDiv>
                                        <NotesOneDisplay 
                                            notesOneDisplay={notesOneDisplay}
                                            editNoteOne={editNoteOne}
                                            checkImpersonationActive={checkImpersonationActive}
                                            checkProxyActive={checkProxyActive}
                                            displayName={displayName}
                                            formatDateddmmmyy={formatDateddmmmyy}
                                            countryISOCode={countryISOCode}
                                            convertTime24To12={convertTime24To12}
                                            MDIEditDisable={MDIEditDisable}
                                            MDIedit={MDIedit}
                                            handleEditOne={handleEditOne}
                                            DeleteIcon={DeleteIcon}
                                            handleDelete={handleDeleteLocal}
                                            setNotesCount={setNotesCount}
                                            editNoteValue={editNoteValue}
                                            setEditNoteOneValue={setEditNoteOneValue}
                                            CloseBlue={CloseBlue}
                                            handleCloseEditOne={handleCloseEditOne}
                                            TickBlue={TickBlue}
                                            handleEditSaveOne={handleEditSaveOne}
                                            setEditNoteOne={setEditNoteOne}
                                            setShowSuccessMessageOne={setShowSuccessMessageOne}
                                            isFromConsignmentBilling={isFromConsignmentBilling}
                                            isFromReportUsage={isFromReportUsage}
                                        />
                                    </div>
                                ) :  null
                            }
                            {showUsageAdjNotes && (
                                <UsageAdjNoteSection
                                    header={t('reportUsage.usageAdjNote.header')}
                                    subHeader={t('reportUsage.usageAdjNote.subHeader')}
                                    notesText={notesThreeText}
                                    onChange={surgeryNoteChangeHandler}
                                    onSave={() => {
                                        setNotesCount((prev) => prev + 1);
                                        handleSaveLocal('noteThree');
                                    }}
                                    onCancel={() =>
                                        notesThreeText.length > 0
                                            ? clearSurgeryNotes('noteThree')
                                            : setViewNotes(false)
                                    }
                                    onDelete={handleDeleteThree}
                                    notesDisplay={notesThreeDisplay}
                                    charCountLimit={charCountLimit}
                                    editIndex={editNoteThree}
                                    editValue={editNoteThreeValue}
                                    onEdit={handleEditThree}
                                    onEditChange={(e) =>
                                        setEditNoteThreeValue(e.target.value)
                                    }
                                    onEditClose={handleCloseEditThree}
                                    onEditSave={handleEditSaveThree}
                                    showSuccessMessage={successMessageThree}
                                />
                            )}
                            </DesktopDivWithBorder>
                        )}
                        {notesVisibility.includes('notes') && (
                            <DesktopDiv>
                                {!isFromEquity && !isFromConsignmentAdd ? (
                                    <DisplayDiv>
                                        <SubtitleDiv>
                                            <Subtitle>{noteTwoHeader}</Subtitle>

                                            {!isIpadDevice ? (
                                                <SurgeryNoteCharactersCount margin="0px 5px 0px 0px">
                                                    {`${
                                                        charCountLimit -
                                                            notesTwoText?.length <
                                                        0
                                                            ? 0
                                                            : charCountLimit -
                                                              notesTwoText?.length
                                                    } ${t(
                                                        'equity.surgery.remainchar'
                                                    )}`}
                                                </SurgeryNoteCharactersCount>
                                            ) : null}
                                        </SubtitleDiv>
                                        {isIpadDevice ? (
                                            <SurgeryNoteCharactersCount margin="0px 5px 5px 0px">
                                                {`${
                                                    charCountLimit - notesTwoText?.length < 0
                                                        ? 0
                                                        : charCountLimit - notesTwoText?.length
                                                } ${t(
                                                    'equity.surgery.remainchar'
                                                )}`}
                                            </SurgeryNoteCharactersCount>
                                        ) : null}
                                        <SurgeryInput
                                            placeholder={
                                                isFromConsignmentBilling
                                                    ? t(
                                                          'common.enterCustomerCareReplenNotes'
                                                      )
                                                    : isFromReportUsage
                                                    ? t(
                                                          'common.enterCustomerCareReplenishNotes'
                                                      )
                                                    : t(
                                                          'equity.surgery.enterSurgeryNotes'
                                                      )
                                            }
                                            value={notesTwoText}
                                            onChange={(e) =>
                                                surgeryNoteChangeHandler(
                                                    e,
                                                    'noteTwo'
                                                )
                                            }
                                            maxLength={textAreaTwoCharLimit}
                                            onKeyPress={handlePopupOnKeyPress}
                                        ></SurgeryInput>

                                        <ButtonDiv justifyContent={'flex-end'}>
                                            <Button
                                                id={
                                                    'common-surgery-notes-clear-button'
                                                }
                                                width={'102px'}
                                                mobileWidth={'150px'}
                                                height={'38px'}
                                                show={true}
                                                variant={ButtonStyles.secondary}
                                                margin={'0px 18px 0px 0px'}
                                                clicked={() => {
                                                    try {
                                                        notesTwoText.length > 0
                                                            ? clearSurgeryNotes(
                                                                  'noteTwo'
                                                              )
                                                            : setViewNotes(false);
                                                    } catch (error) {
                                                        logErrorToConsole(error);
                                                    }
                                                }}
                                            >
                                                <StyledDiv>
                                                    {t('common.cancelButton')}
                                                </StyledDiv>
                                            </Button>
                                            <Button
                                                id={
                                                    'common-surgery-notes-save-button-two'
                                                }
                                                width={'102px'}
                                                mobileWidth={'150px'}
                                                height={'38px'}
                                                show={true}
                                                variant={
                                                    notesTwoText?.trim()
                                                        ?.length > 0
                                                        ? ButtonStyles.primary
                                                        : ButtonStyles.surgeryNotesDisabled
                                                }
                                                disabled={notesTwoText.trim().length === 0}
                                                clicked={() => {
                                                    try {
                                                        if (
                                                            notesTwoText?.trim() ?.length > 0
                                                        ) {
                                                            setNotesCount(
                                                                (prev) => prev + 1
                                                            );
                                                            handleSaveLocal(
                                                                'noteTwo'
                                                            );
                                                        }
                                                    } catch (error) {
                                                        logErrorToConsole(error);
                                                    }
                                                }}
                                            >
                                                <StyledDiv>
                                                    {t('more.common.save')}
                                                </StyledDiv>
                                            </Button>
                                        </ButtonDiv>
                                        <Line></Line>
                                    </DisplayDiv>
                                ) : null}
                                <div
                                    style={{
                                        marginTop:
                                            isFromConsignmentAdd || isFromEquity
                                                ? '20px'
                                                : '20px',
                                    }}
                                >
                                    <SubtitleDiv>
                                        <Subtitle margin="0 0 5px 0">
                                            {noteTwoSubHeader}
                                        </Subtitle>
                                        {successMessageTwo &&
                                        window.innerWidth >= sizes.mobileDevice ? (
                                            <SuccessMsgContainer 
                                                marginRight={'5px'}
                                            />
                                        ) : null}
                                    </SubtitleDiv>
                                    <NotesTwoDisplay
                                        notesTwoDisplay={notesTwoDisplay}
                                        editNoteTwo={editNoteTwo}
                                        checkImpersonationActive={checkImpersonationActive}
                                        checkProxyActive={checkProxyActive}
                                        displayName={displayName}
                                        formatDateddmmmyy={formatDateddmmmyy}
                                        countryISOCode={countryISOCode}
                                        convertTime24To12={convertTime24To12}
                                        MDIEditDisable={MDIEditDisable}
                                        MDIedit={MDIedit}
                                        handleEditTwo={handleEditTwo}
                                        DeleteIcon={DeleteIcon}
                                        handleDelete={handleDeleteLocal}
                                        setNotesCount={setNotesCount}
                                        editNoteTwoValue={editNoteTwoValue}
                                        setEditNoteTwoValue={setEditNoteTwoValue}
                                        CloseBlue={CloseBlue}
                                        handleCloseEditTwo={handleCloseEditTwo}
                                        TickBlue={TickBlue}
                                        handleEditSaveTwo={handleEditSaveTwoLocal}
                                        setEditNoteTwo={setEditNoteTwo}
                                        setShowSuccessMessageTwo={setShowSuccessMessageTwo}
                                        isFromConsignmentBilling={isFromConsignmentBilling}
                                        isFromReportUsage={isFromReportUsage}
                                        isFromConsignmentAdd={isFromConsignmentAdd}
                                        isFromEquity={isFromEquity}
                                    />
                                </div>
                            </DesktopDiv>
                        )}
                    </DesktopContainer> 
                ) : (
                    // Mobile View
                   (isReportUsageMobileView ||
                   window.innerWidth <= sizes.mobileDevice)?
                   <>
                        <Hideflex isFromEquity={isFromEquity} isCondensedView={isCondensedView} isSurgery={isSurgery} bannerHeight={bannerHeight}>
                            <SurgeryNote isFromEquity={isFromEquity} isCondensedView={isCondensedView} isSurgery={isSurgery} bannerHeight={bannerHeight}>
                                {isFromConsignmentAdd ||
                                isFromConsignmentBilling ||
                                isFromEquity ||
                                isFromReportUsage
                                    ? t('reportUsage.customerCareNotes')
                                    : t(
                                          'scheduleSurgery.surgery.SurgeryNotes.surgeryNotes'
                                      )}
                            </SurgeryNote>
                            <SurgeryClose
                                isFromEquity={isFromEquity} 
                                isCondensedView={isCondensedView}
                                isSurgery={isSurgery}
                                bannerHeight={bannerHeight}
                            >
                                <img
                                    src={CloseProduct}
                                    onClick={() => setViewNotes(false)}
                                ></img>
                            </SurgeryClose>
                        </Hideflex>
                        <AccountContainer>
                            <AccountGridContainer
                                container
                                justifyContent={'space-between'}
                                direction="row"
                            >
                                <AccountGrid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    xl={12}
                                    mobile={12}
                                >
                                    <MainTitle
                                        onClick={() =>
                                            toggleCard1(
                                                'itemDetails',
                                                !expandedCard1.itemDetails
                                            )
                                        }
                                    >
                                        {isFromEquity || isFromConsignmentAdd
                                            ? t('reportUsage.customerCareNotes')
                                            : isFromConsignmentBilling
                                            ? t(
                                                  'reportUsage.consignmentBillingNotes'
                                              )
                                            : isFromReportUsage
                                            ? t('reportUsage.usageNotes')
                                            : t(
                                                  'scheduleSurgery.surgery.SurgeryReviewAndSuccess.customerCareSuregeryNotes'
                                              )}
                                        <ImageBox>
                                            <ImageContainer
                                                src={DownArrowFilter}
                                                alt="down-arrow"
                                                isExpanded={
                                                    expandedCard1.itemDetails
                                                }
                                                onClick={() =>
                                                    toggleCard1(
                                                        'itemDetails',
                                                        !expandedCard1.itemDetails
                                                    )
                                                }
                                                style={{
                                                    marginTop: isMobileDevice()
                                                        ? ''
                                                        : '3px',
                                                    marginLeft: '20px',
                                                    width: isMobileDevice()
                                                        ? ''
                                                        : '18px',
                                                    height: isMobileDevice()
                                                        ? ''
                                                        : '25px',
                                                    display: 'flex',
                                                }}
                                            />
                                        </ImageBox>
                                    </MainTitle>
                                </AccountGrid>
                                {expandedCard1.itemDetails ? (
                                    <>
                                        <AccountGrid
                                            item
                                            xs={
                                                isFromEquity || isFromConsignmentAdd
                                                    ? 12
                                                    : 12
                                            }
                                            sm={
                                                isFromEquity || isFromConsignmentAdd
                                                    ? 12
                                                    : 5
                                            }
                                            md={
                                                isFromEquity || isFromConsignmentAdd
                                                    ? 12
                                                    : 5
                                            }
                                            lg={
                                                isFromEquity || isFromConsignmentAdd
                                                    ? 12
                                                    : 5
                                            }
                                            xl={
                                                isFromEquity || isFromConsignmentAdd
                                                    ? 12
                                                    : 5
                                            }
                                            mobile={
                                                isFromEquity || isFromConsignmentAdd
                                                    ? 12
                                                    : 5
                                            }
                                        >
                                            <DesktopDiv>
                                                <DisplayDiv>
                                                    <SurgeryInput
                                                        placeholder={
                                                            isFromConsignmentAdd ||
                                                            isFromEquity
                                                                ? t(
                                                                      'reportUsage.EnterCustomerCareNotes'
                                                                  )
                                                                : isFromConsignmentBilling
                                                                ? t(
                                                                      'common.enterCustomerCareBillingNotes'
                                                                  )
                                                                : isFromReportUsage
                                                                ? t(
                                                                      'common.enterCustomerCareUsageNotes'
                                                                  )
                                                                : t(
                                                                      'common.enterCustomerCareSurgeryNotes'
                                                                  )
                                                        }
                                                        value={notesOnetext}
                                                        onChange={(e) =>
                                                            surgeryNoteChangeHandler(
                                                                e,
                                                                'noteOne'
                                                            )
                                                        }
                                                        maxLength={
                                                            textAreaOneCharLimit
                                                        }
                                                        onKeyPress={
                                                            handlePopupOnKeyPress
                                                        }
                                                    ></SurgeryInput>
                                                    <SurgeryNoteCharactersCount margin="0px 5px 0px 0px">
                                                        {`${
                                                            charCountLimit -
                                                                notesOnetext?.length <
                                                            0
                                                                ? 0
                                                                : charCountLimit -
                                                                  notesOnetext?.length
                                                        } ${t(
                                                            'equity.surgery.remainchar'
                                                        )}`}
                                                    </SurgeryNoteCharactersCount>
                                                    <ButtonDiv
                                                        justifyContent={
                                                            'flex-end'
                                                        }
                                                    >
                                                        <Button
                                                            id={
                                                                'common-surgery-notes-clear-button'
                                                            }
                                                            width={'102px'}
                                                            mobileWidth={
                                                                '155px'
                                                            }
                                                            variant={
                                                                ButtonStyles.secondary
                                                            }
                                                            height={'38px'}
                                                            show={true}
                                                            clearNotesBg={true}
                                                            margin={
                                                                '0px 18px 0px 0px'
                                                            }
                                                            clicked={() => {
                                                                try {
                                                                    notesOnetext.length >
                                                                    0
                                                                        ? clearSurgeryNotes(
                                                                              'noteOne'
                                                                          )
                                                                        : setViewNotes(
                                                                              false
                                                                          );
                                                                } catch (error) {
                                                                    logErrorToConsole(error);
                                                                }
                                                            }}
                                                        >
                                                            <StyledDiv>
                                                                {t(
                                                                    'reportUsage.reportUsageFooterbuttons.cancelButton'
                                                                )}
                                                            </StyledDiv>
                                                        </Button>

                                                        <Button
                                                            id={
                                                                'common-surgery-notes-save-button-one'
                                                            }
                                                            width={'102px'}
                                                            mobileWidth={
                                                                '150px'
                                                            }
                                                            height={'38px'}
                                                            show={true}
                                                            variant={
                                                                notesOnetext.trim()
                                                                    .length > 0
                                                                    ? ButtonStyles.primary
                                                                    : ButtonStyles.surgeryNotesDisabled
                                                            }
                                                            disabled={notesOnetext.trim().length === 0}
                                                            clicked={() => {
                                                                try {
                                                                    if (
                                                                        notesOnetext.trim()
                                                                            .length >
                                                                        0
                                                                    ) {
                                                                        setNotesCount(
                                                                            (
                                                                                prev
                                                                            ) =>
                                                                                prev +
                                                                                1
                                                                        );
                                                                        handleSaveLocal(
                                                                            'noteOne'
                                                                        );
                                                                    }
                                                                } catch (error) {
                                                                    logErrorToConsole(error);
                                                                }
                                                            }}
                                                        >
                                                            <StyledDiv>
                                                                {t(
                                                                    'more.common.save'
                                                                )}
                                                            </StyledDiv>
                                                        </Button>
                                                    </ButtonDiv>
                                                </DisplayDiv>
                                            </DesktopDiv>
                                            {successMessageOne &&
                                            window.innerWidth <=
                                                sizes.mobileDevice ? (
                                                <SuccessMsgContainer 
                                                    marginRight={'5px'}
                                                    marginBottom={'5px'}
                                                />
                                            ) : null}
                                            <NotesOneContainer
                                                notesOneDisplay={
                                                    notesOneDisplay
                                                }
                                                editNoteOne={editNoteOne}
                                                setEditNoteOneValue={
                                                    setEditNoteOneValue
                                                }
                                                handleEditOne={handleEditOne}
                                                handleDelete={handleDeleteLocal}
                                                setNotesCount={setNotesCount}
                                                editNoteValue={editNoteValue}
                                                handleCloseEditOne={
                                                    handleCloseEditOne
                                                }
                                                handleEditSaveOne={
                                                    handleEditSaveOne
                                                }
                                                setEditNoteOne={setEditNoteOne}
                                                setShowSuccessMessageOne={
                                                    setShowSuccessMessageOne
                                                }
                                                CloseBlue={CloseBlue}
                                                TickBlue={TickBlue}
                                            />
                                        </AccountGrid>
                                    </>
                                ) : null}
                            </AccountGridContainer>
                        </AccountContainer>
                        {showUsageAdjNotes && (
                            <AccountContainer>
                                <AccountGridContainer
                                    container
                                    justifyContent={'space-between'}
                                    direction="row"
                                >
                                    <AccountGrid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={12}
                                        mobile={12}
                                    >
                                        <MainTitle
                                            onClick={() =>
                                                toggleCard3(
                                                    'itemDetails',
                                                    !expandedCard3.itemDetails
                                                )
                                            }
                                        >
                                            {t('reportUsage.usageAdjNote.subHeader')}
                                            <ImageBox>
                                                <ImageContainer
                                                    src={DownArrowFilter}
                                                    alt="down-arrow"
                                                    isExpanded={
                                                        expandedCard3.itemDetails
                                                    }
                                                    onClick={() =>
                                                        toggleCard3(
                                                            'itemDetails',
                                                            !expandedCard3.itemDetails
                                                        )
                                                    }
                                                    style={{
                                                        marginTop: isMobileDevice()
                                                            ? ''
                                                            : '3px',
                                                        marginLeft: '20px',
                                                        width: isMobileDevice()
                                                            ? ''
                                                            : '18px',
                                                        height: isMobileDevice()
                                                            ? ''
                                                            : '25px',
                                                        display: 'flex',
                                                    }}
                                                />
                                            </ImageBox>
                                        </MainTitle>
                                    </AccountGrid>
                                    {expandedCard3.itemDetails ? (
                                        <AccountGrid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={12}
                                            xl={12}
                                            mobile={12}
                                        >
                                            <UsageAdjNoteSection
                                                header={t('reportUsage.usageAdjNote.header')}
                                                subHeader={t('reportUsage.usageAdjNote.subHeader')}
                                                notesText={notesThreeText}
                                                onChange={surgeryNoteChangeHandler}
                                                onSave={() => {
                                                    setNotesCount((prev) => prev + 1);
                                                    handleSaveLocal('noteThree');
                                                }}
                                                onCancel={() =>
                                                    notesThreeText.length > 0
                                                        ? clearSurgeryNotes('noteThree')
                                                        : setViewNotes(false)
                                                }
                                                onDelete={handleDeleteThree}
                                                notesDisplay={notesThreeDisplay}
                                                charCountLimit={charCountLimit}
                                                hideHeader={true}
                                                mobile={true}
                                                editIndex={editNoteThree}
                                                editValue={editNoteThreeValue}
                                                onEdit={handleEditThree}
                                                onEditChange={(e) =>
                                                    setEditNoteThreeValue(
                                                        e.target.value
                                                    )
                                                }
                                                onEditClose={handleCloseEditThree}
                                                onEditSave={handleEditSaveThree}
                                                showSuccessMessage={
                                                    successMessageThree
                                                }
                                            />
                                        </AccountGrid>
                                    ) : null}
                                </AccountGridContainer>
                            </AccountContainer>
                        )}
                        {!isFromEquity && !isFromConsignmentAdd && (
                            <AccountContainer marginBottom={'150px'}>
                                <AccountGridContainer
                                    container
                                    justifyContent={'space-between'}
                                    direction="row"
                                >
                                    <AccountGrid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={12}
                                        mobile={12}
                                    >
                                        <MainTitle
                                            onClick={() =>
                                                toggleCard2(
                                                    'itemDetails',
                                                    !expandedCard2.itemDetails
                                                )
                                            }
                                        >
                                            {isFromConsignmentBilling
                                                ? t(
                                                      'reportUsage.consignmentReplenishmentNotes'
                                                  )
                                                : isFromReportUsage
                                                ? t(
                                                      'common.usageReplenishNotes'
                                                  )
                                                : t(
                                                      'scheduleSurgery.surgery.SurgeryNotes.surgeryNotes'
                                                  )}
                                            <ImageBox>
                                                <ImageContainer
                                                    src={DownArrowFilter}
                                                    alt="down-arrow"
                                                    isExpanded={
                                                        expandedCard2.itemDetails
                                                    }
                                                    onClick={() =>
                                                        toggleCard2(
                                                            'itemDetails',
                                                            !expandedCard2.itemDetails
                                                        )
                                                    }
                                                    style={{
                                                        marginTop:
                                                            isMobileDevice()
                                                                ? ''
                                                                : '3px',
                                                        marginLeft: '20px',
                                                        width: isMobileDevice()
                                                            ? ''
                                                            : '18px',
                                                        height: isMobileDevice()
                                                            ? ''
                                                            : '25px',
                                                        display: 'flex',
                                                    }}
                                                />
                                            </ImageBox>
                                        </MainTitle>
                                    </AccountGrid>
                                    {expandedCard2.itemDetails ? (
                                        <>
                                            {!isFromEquity &&
                                                !isFromConsignmentAdd && (
                                                    <AccountGrid
                                                        item
                                                        xs={12}
                                                        sm={5}
                                                        md={5}
                                                        lg={5}
                                                        xl={5}
                                                        mobile={5}
                                                    >
                                                        <DesktopDiv>
                                                            <DisplayDiv>
                                                                <SurgeryInput
                                                                    placeholder={
                                                                        isFromConsignmentBilling
                                                                            ? t(
                                                                                  'common.enterCustomerCareReplenNotes'
                                                                              )
                                                                            : isFromReportUsage
                                                                            ? t(
                                                                                  'common.enterCustomerCareReplenishNotes'
                                                                              )
                                                                            : t(
                                                                                  'equity.surgery.enterSurgeryNotes'
                                                                              )
                                                                    }
                                                                    value={
                                                                        notesTwoText
                                                                    }
                                                                    onChange={(e) =>
                                                                        surgeryNoteChangeHandler(e,'noteTwo')
                                                                    }
                                                                    maxLength={
                                                                        textAreaTwoCharLimit
                                                                    }
                                                                    onKeyPress={
                                                                        handlePopupOnKeyPress
                                                                    }
                                                                ></SurgeryInput>
                                                                <SurgeryNoteCharactersCount margin="0px 5px 0px 0px">
                                                                    {`${
                                                                        charCountLimit - notesTwoText?.length < 0
                                                                            ? 0
                                                                            : charCountLimit - notesTwoText?.length
                                                                    } ${t(
                                                                        'equity.surgery.remainchar'
                                                                    )}`}
                                                                </SurgeryNoteCharactersCount>
                                                                <ButtonDiv
                                                                    justifyContent={
                                                                        'flex-end'
                                                                    }
                                                                >
                                                                    <Button
                                                                        id={
                                                                            'common-surgery-notes-clear-button'
                                                                        }
                                                                        width={
                                                                            '102px'
                                                                        }
                                                                        mobileWidth={
                                                                            '150px'
                                                                        }
                                                                        height={
                                                                            '38px'
                                                                        }
                                                                        show={
                                                                            true
                                                                        }
                                                                        variant={
                                                                            ButtonStyles?.secondary
                                                                        }
                                                                        clearNotesBg={
                                                                            true
                                                                        }
                                                                        margin={
                                                                            '0px 18px 0px 0px'
                                                                        }
                                                                        clicked={() => {
                                                                            try {
                                                                                notesTwoText.length > 0
                                                                                    ? clearSurgeryNotes(
                                                                                          'noteTwo'
                                                                                      )
                                                                                    : setViewNotes(
                                                                                          false
                                                                                      );
                                                                            } catch (error) {
                                                                                logErrorToConsole(error);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <StyledDiv>
                                                                            {t(
                                                                                'reportUsage.reportUsageFooterbuttons.cancelButton'
                                                                            )}
                                                                        </StyledDiv>
                                                                    </Button>
                                                                    <Button
                                                                        id={
                                                                            'common-surgery-notes-save-button-two'
                                                                        }
                                                                        width={
                                                                            '102px'
                                                                        }
                                                                        mobileWidth={
                                                                            '150px'
                                                                        }
                                                                        height={
                                                                            '38px'
                                                                        }
                                                                        show={true}
                                                                        variant={
                                                                            notesTwoText?.trim()?.length > 0
                                                                                ? ButtonStyles?.primary
                                                                                : ButtonStyles?.surgeryNotesDisabled
                                                                        }
                                                                        disabled={notesTwoText.trim().length === 0}
                                                                        clicked={() => {
                                                                            try {
                                                                                if (
                                                                                    notesTwoText?.trim()?.length > 0
                                                                                ) {
                                                                                    setNotesCount((prev) => prev + 1);
                                                                                    handleSaveLocal('noteTwo');
                                                                                }
                                                                            } catch (error) {
                                                                                logErrorToConsole(error);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <StyledDiv>
                                                                            {t(
                                                                                'more.common.save'
                                                                            )}
                                                                        </StyledDiv>
                                                                    </Button>
                                                                </ButtonDiv>
                                                            </DisplayDiv>
                                                        </DesktopDiv>
                                                        {successMessageTwo &&
                                                        window.innerWidth <=
                                                            sizes.mobileDevice ? (
                                                                <SuccessMsgContainer marginRight={'5px'} marginBottom={'5px'} />
                                                        ) : null}
                                                        <NotesTwoContainer
                                                            notesTwoDisplay={notesTwoDisplay}
                                                            editNoteTwo={editNoteTwo}
                                                            editNoteTwoValue={editNoteTwoValue}
                                                            setEditNoteTwoValue={setEditNoteTwoValue}
                                                            handleEditTwo={handleEditTwo}
                                                            handleDelete={handleDeleteLocal}
                                                            setNotesCount={setNotesCount}
                                                            handleCloseEditTwo={handleCloseEditTwo}
                                                            handleEditSaveTwo={handleEditSaveTwoLocal}
                                                            setEditNoteTwo={setEditNoteTwo}
                                                            setShowSuccessMessageTwo={setShowSuccessMessageTwo}
                                                            CloseBlue={CloseBlue}
                                                            TickBlue={TickBlue}
                                                        />
                                                    </AccountGrid>
                                                )}
                                        </>
                                    ) : null}
                                </AccountGridContainer>
                            </AccountContainer>
                        )}
                    </> : null
                )}

                {surgeryNotesPopup && (
                    <AddedMoreThanTenItems
                        title={t('common.itemFormTitle')}
                        onClose={() => setSurgeryNotesPopup(false)}
                    />
                )}
            </Div>
        </>
    );
};

export default CustomerCareNotes;
